module.exports = __webpack_public_path__ + "6ab99ee581a8a3cf5c60819866fdeb1f.svg";